import React from "react";
import {Box, Chip, Typography} from "@mui/material";

function formatDate(value) {
    if (!value) {
        return "—";
    }
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? value : d.toLocaleString();
}

function formatTagLabel(tag) {
    if (tag == null || tag.id == null) {
        return "—";
    }
    return `(${tag.id}) - ${String(tag.name ?? "")}`;
}

const detailLabelSx = {
    fontFamily: "LarsseitMedium",
    fontSize: "0.8125rem",
    color: "#0C2728",
    mb: 0.5,
};

const detailValueSx = {
    fontFamily: "LarsseitRegular",
    fontSize: "0.875rem",
    color: "#495D5E",
};

const mutedSx = {
    fontFamily: "LarsseitRegular",
    fontSize: "0.875rem",
    color: "#495D5E",
};

function DetailField({label, children}) {
    return (
        <Box>
            <Typography sx={detailLabelSx}>{label}</Typography>
            {children}
        </Box>
    );
}

export default function AutoActionTypeDetails({row}) {
    const type = row?.type;

    if (type === "KeywordAutoAction" || type === "ThreadKeywordAutoAction") {
        const keywords = Array.isArray(row.keywords) ? row.keywords : [];
        if (keywords.length === 0) {
            return <Typography sx={mutedSx}>No keywords.</Typography>;
        }
        return (
            <DetailField label="Keywords">
                <Box sx={{display: "flex", flexWrap: "wrap", gap: 0.75}}>
                    {keywords.map((keyword, index) => (
                        <Chip
                            key={`${keyword}-${index}`}
                            label={keyword}
                            size="small"
                            variant="outlined"
                            sx={{
                                fontFamily: "LarsseitRegular",
                                fontSize: "0.8125rem",
                                color: "#0C2728",
                                borderColor: "#CED4D4",
                                bgcolor: "#FFFFFF",
                            }}
                        />
                    ))}
                </Box>
            </DetailField>
        );
    }

    if (type === "TagAutoAction") {
        return (
            <Box sx={{display: "flex", flexDirection: "column", gap: 1.25}}>
                <DetailField label="Tag">
                    <Typography sx={detailValueSx}>{formatTagLabel(row.tag)}</Typography>
                </DetailField>
                <DetailField label="Message tag match">
                    <Typography sx={detailValueSx}>{row.messageTagMatch ?? "—"}</Typography>
                </DetailField>
            </Box>
        );
    }

    if (type === "MetadataRatingAutoAction") {
        return (
            <Box sx={{display: "flex", flexDirection: "column", gap: 1.25}}>
                <DetailField label="Comparison">
                    <Typography sx={detailValueSx}>{row.comparison ?? "—"}</Typography>
                </DetailField>
                <DetailField label="Rating limit">
                    <Typography sx={detailValueSx}>
                        {row.ratingLimit == null ? "—" : String(row.ratingLimit)}
                    </Typography>
                </DetailField>
            </Box>
        );
    }

    if (type === "MlAutoAction") {
        return (
            <DetailField label="Query messages from">
                <Typography sx={detailValueSx}>{formatDate(row.queryMessagesFrom)}</Typography>
            </DetailField>
        );
    }

    return <Typography sx={mutedSx}>No extra fields.</Typography>;
}
